import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { compose } from 'common/helpers'

import Button from 'components/buttons/Button/Button'
import RedeemButton from 'components/buttons/RedeemButton/RedeemButton'
import ResubscribeButton from 'components/buttons/ResubscribeButton/ResubscribeButton'
import UnpauseButton from 'components/buttons/UnpauseButton/UnpauseButton'
import OpenUpgradeButton from 'components/buttons/UpgradeButton/OpenUpgradeButton/OpenUpgradeButton'

import SubscribeTodayForJust from './SubscribeTodayForJust/SubscribeTodayForJust'


const SubscriptionBlock = (props) => {
  const {
    className, dataTestId, metadata,
    me: { isLoggedIn, isFetching, hasMarketingCoupon, giftSubscription },
    subscription: { isUpgradable, isCancelled, isSubscribed, isPaused },
  } = props

  // TODO move this to helpers to use outside component. For example Sidebar on Extras page contains this component only
  // TODO need to hide Sidebar when this component is empty
  const isRedeemButtonVisible = Boolean(
    isLoggedIn
    && !isSubscribed
    && (
      hasMarketingCoupon
      || (giftSubscription && giftSubscription.code && giftSubscription.activated === false)
    ),
  )

  const isSubscribeTodayBlockVisible = Boolean(
    !isLoggedIn
    || (
      !isSubscribed
      && !isCancelled
      && !hasMarketingCoupon
      && (!giftSubscription || !giftSubscription.code || giftSubscription.activated)
    ),
  )

  const isUpgradeButtonVisible = isLoggedIn && isSubscribed && isUpgradable
  const isResubscribeButtonVisible = isLoggedIn && isCancelled && !isRedeemButtonVisible
  const isVisible = (
    isRedeemButtonVisible
    || isSubscribeTodayBlockVisible
    || isUpgradeButtonVisible
    || isResubscribeButtonVisible
    || isPaused
  )

  if (!isVisible) {
    return null
  }

  // TODO remove or resolve `isFetching`. Now it placed in `reducers/auth.js`

  return !isFetching ? (
    <div className={className} data-testid={dataTestId}>
      {
        isRedeemButtonVisible && (
          <RedeemButton
            weight="normal"
            color="brand"
            size="md"
            fullWidth
            dataTestId="subscriptionBlock_redeemButton"
          />
        )
      }
      {
        isResubscribeButtonVisible && (
          <ResubscribeButton
            placement="sidebar"
            fullWidth
            dataTestId="subscriptionBlock_resubscribeButton"
          />
        )
      }
      {
        isSubscribeTodayBlockVisible && (
          <SubscribeTodayForJust
            isLoggedIn={isLoggedIn}
            id="subscriptionBlock_subscribeTodayForJust1495Button"
          />
        )
      }
      {
        isUpgradeButtonVisible && (
          <OpenUpgradeButton
            size="sm"
            fullWidth
            placement={metadata.placement}
            snowplowPlacement="sidebar"
            dataTestId="subscriptionBlock_upgradeButton"
          />
        )
      }
      {
        isPaused && (
          <UnpauseButton
            placement="sidebar"
            fullWidth
            dataTestId="subscriptionBlock_unpauseButton"
          />
        )
      }
    </div>
  ) : (
    <div className={className}>
      <Button md loading fullWidth />
    </div>
  )
}

SubscriptionBlock.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  metadata: PropTypes.shape({
    placement: PropTypes.string.isRequired,
  }),
  me: PropTypes.object,
  subscription: PropTypes.object,
}

SubscriptionBlock.defaultProps = {
  metadata: { placement: 'smartsearch' },
}


export default compose(
  connect({
    me: 'models.me',
    subscription: 'models.subscription',
  }),
)(SubscriptionBlock)
